<div class="workflow-manager-container" *ngIf="workflowLoaded">
    <app-workflow-dynamic 
        [componentModel]="workflow"
        [componentData]="dto.data">
    </app-workflow-dynamic>
</div>

